<div
  [ngClass]="{ 'hide-bottom-panel': hideBottomPanel === true }"
  *ngIf="active"
  class="bottom-panel"
  #bottomPanelElementRef
  mwlResizable
  [enableGhostResize]="true"
  [resizeEdges]="{ bottom: false, right: false, top: true, left: false }"
  [validateResize]="validateResize"
  (resizeEnd)="onResizeEnd($event)"
>
  <!-- Resize drag handler -->
  <div
    *ngIf="collapseStatus !== CollapseStatusEnum.collapsed"
    class="resize-handle"
    mwlResizeHandle
    [resizeEdges]="{ top: true }"
    [ngClass]="{
      'bottom-panel-filtering': isFiltering
    }"
  >
    <mat-icon class="mat-icon-size-18">drag_handle</mat-icon>
  </div>

  <!-- panel grip -->
  <mat-grid-list
    cols="3"
    rowHeight="25px"
    class="panel-grip"
    [ngClass]="{
      'bottom-panel-filtering': isFiltering
    }"
  >
    <mat-grid-tile></mat-grid-tile>
    <mat-grid-tile (click)="toggleVisibility()">
      <div class="bottom-panel-title">
        <span>{{ 'LIST_VIEW.TITLE' | translate }}</span>
        <mat-icon *ngIf="collapseStatus === CollapseStatusEnum.open"> arrow_drop_down </mat-icon>
        <mat-icon *ngIf="collapseStatus === CollapseStatusEnum.collapsed"> arrow_drop_up </mat-icon>
      </div>
    </mat-grid-tile>
    <mat-grid-tile>
      <div *ngIf="collapseStatus !== CollapseStatusEnum.collapsed" class="panel-height-toggle">
        <button mat-button class="btn-toggle" (click)="toggleVisibility()">
          <div class="none"></div>
        </button>
        <button
          mat-button
          class="btn-toggle"
          (click)="setPanelPresetHeight(BottomPanelPresetHeight.small)"
        >
          <div class="small"></div>
        </button>
        <button
          mat-button
          class="btn-toggle"
          (click)="setPanelPresetHeight(BottomPanelPresetHeight.big)"
        >
          <div class="big"></div>
        </button>
      </div>
    </mat-grid-tile>
  </mat-grid-list>

  <div
    class="table-wrapper"
    [collapse]="collapseStatus === CollapseStatusEnum.collapsed"
    [isAnimated]="true"
    [ngClass]="{
      'display-block': collapseStatus === CollapseStatusEnum.open,
      'display-none': collapseStatus === CollapseStatusEnum.collapsed
    }"
  >
    <div [style.height.px]="currentHeight">
      <ag-grid-list-view></ag-grid-list-view>
    </div>
  </div>
</div>
